// Copyright (c) 2017 Deere & Company

import './index.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import Attachments from '../../shared/components/attachments';
import {FormattedMessage} from 'react-intl';
import LabeledDateInput from '../../../claim/shared/components/claim-fields/labeled-date-input';
import LabeledInput from '../../../claim/shared/components/claim-fields/labeled-input';
import LabeledTextArea from '../../../claim/shared/components/claim-fields/labeled-text-area';
import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import LaborRateMain from './labor-rate-main';
import LaborRateModal from './modal';
import LaborRates from './labor-rates';
import {Link} from 'react-router';
import SecureApproveDenyButtonGroup from '../../shared/components/secure-approve-deny-button-group';
import TcsmApproveDenyModal from '../../wip/state/tcsm-approve-deny-modal';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {isNotEmpty} from '../../../claim/shared/services/claim-shared-helper';
const disabled = true;
const editable = false;

const isDisabled = props =>
    props.selectedDealers.length === 0 || props.laborRate[0].overrideEffectiveDate && !isNotEmpty(props.laborRate[0].reasonForOverride) ? disabled : editable;

function handleApprove() {

    this.actions.openModal('APPROVE');
    this.actions.updateStatus('ACCEPTED');

}

function handleDeny() {

    this.actions.openModal('REJECT');
    this.actions.updateStatus('REJECTED');

}

function handleReturn() {

    this.actions.openModal('RETURN');
    this.actions.updateStatus('RETURNED');

}

function handleOverrideEffectiveDateChange(date) {

    this.actions.updateOverrideEffectiveDate(date);

}

function handleReasonForOverrideChange(reason) {

    this.actions.updateReasonForOverride(reason);

}

function handleCommentsToDealerChange(event) {

    this.actions.updateCommentsToDealer(event.target.value);

}

function handleInternalDeereCommentsChange(event) {

    this.actions.updateInternalDeereComments(event.target.value);

}

function handleConfirmation() {

    this.actions.updateLaborRate(this.selectedDealers, this.modal.actionToTake);

}

class TcsmLaborRateChange extends Component {

    componentWillMount() {

        this.props.actions.readLaborRates(this.props.routeParams.account);
        this.props.actions.resetSelectedDealers();

    }

    render() {

        return (
            <section className='labor-rate-change'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                {this.props.laborRate.length > 0 &&
                <section>
                    <h2 className='title-row'>
                        <section className='dealer-name'>
                            {this.props.laborRate[0].requestId}
                        </section>
                        <section className='buttons'>
                            <Link
                                className='button-secondary'
                                to='/tcsm/wip'
                            >
                                <FormattedMessage id='CANCEL'/>
                            </Link>
                            <SecureApproveDenyButtonGroup
                                isApproveDisabled={isDisabled(this.props)}
                                isDenyDisabled={isDisabled(this.props)}
                                isReturnDisabled={isDisabled(this.props)}
                                isShowReturnButton={true}
                                onApprove={this.props::handleApprove}
                                onDeny={this.props::handleDeny}
                                onReturn={this.props::handleReturn}
                                securityFeature='TCSM_LABOR_RATE_PROCESS'
                                securityModule='TCSM'
                            />
                        </section>
                    </h2>
                    <LaborRateMain
                        actions={this.props.actions}
                        allSelected={this.props.allSelected}
                        laborRate={this.props.laborRate[0]}
                        tcsm={true}
                    >
                        <LaborRates
                            actions={this.props.actions}
                            allSelected={this.props.allSelected}
                            laborRates={this.props.laborRate}
                            selectedDealers={this.props.selectedDealers}
                        />
                        <LabeledInput
                            className='dealer_comments'
                            isEditable={false}
                            label='DEALER_COMMENTS'
                            value={this.props.laborRate[0].rates[0].reasonForChange}
                        />
                        <LabeledDateInput
                            className='override-effective-date'
                            date={this.props.laborRate[0].overrideEffectiveDate}
                            isEditable={true}
                            isValid={true}
                            label='OVERRIDE_EFFECTIVE_DATE'
                            onDateChange={this.props::handleOverrideEffectiveDateChange}
                        />
                        {this.props.laborRate[0].overrideEffectiveDate &&
                            <LabeledTextArea
                                className='reason-for-override'
                                isEditable={true}
                                label='REASON_FOR_OVERRIDE'
                                maxLength={255}
                                onChange={this.props::handleReasonForOverrideChange}
                                rows={5}
                                value={this.props.laborRate.reasonForOverride}
                            />
                            }

                        {this.props.laborRate[0].file.fileName &&
                            <Attachments files={[this.props.laborRate[0].file]}/>
                        }
                    </LaborRateMain>
                    <LaborRateModal
                        laborRate={this.props.laborRate[0]}
                        laborRateModal={this.props.modal}
                        onClose={this.props.actions.closeModal}
                        onCommentsToDealerChange={this.props::handleCommentsToDealerChange}
                        onConfirmation={this.props::handleConfirmation}
                        onInternalDeereCommentsChange={this.props::handleInternalDeereCommentsChange}
                    />
                </section>}
            </section>
        );

    }
}

TcsmLaborRateChange.displayName = 'TcsmLaborRateChange';
TcsmLaborRateChange.propTypes = {
    actions: PropTypes.object.isRequired,
    allSelected: PropTypes.bool,
    busyCounter: PropTypes.number.isRequired,
    laborRate: PropTypes.arrayOf(PropTypes.instanceOf(LaborRate)).isRequired,
    modal: PropTypes.instanceOf(TcsmApproveDenyModal).isRequired,
    routeParams: PropTypes.object.isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(LaborRate)).isRequired
};
export default TcsmLaborRateChange;



// WEBPACK FOOTER //
// ./src/tcsm/labor-rate-approval/components/index.js